import script from "./OnlineCustomerService.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineCustomerService.vue?vue&type=script&setup=true&lang=js"

import "./OnlineCustomerService.vue?vue&type=style&index=0&id=6b8dc4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8dc4ae"]])

export default __exports__